import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, keywords, url, image }) {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "ZENCON Ltd. Co.",
    url: "https://www.zencon-sa.com",
    logo: "https://www.zencon-sa.com/logo.png",
    description:
      "SAP consulting, enterprise solutions, and digital transformation company in Saudi Arabia.",
    areaServed: "Saudi Arabia",
  };

  return (
    <Helmet>
      {/* BASIC SEO */}

      <title>{title}</title>

      <meta name="description" content={description} />

      <meta name="keywords" content={keywords} />

      <meta name="robots" content="index, follow" />

      <link rel="canonical" href={url} />

      {/* OPEN GRAPH */}

      <meta property="og:type" content="website" />

      <meta property="og:title" content={title} />

      <meta property="og:description" content={description} />

      <meta property="og:url" content={url} />

      <meta property="og:image" content={image} />

      {/* TWITTER SEO */}

      <meta name="twitter:card" content="summary_large_image" />

      <meta name="twitter:title" content={title} />

      <meta name="twitter:description" content={description} />

      <meta name="twitter:image" content={image} />

      {/* STRUCTURED DATA */}

      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
}
